"use client"
import { useDataSaver } from "@/lib/hooks/useDataSaver"

/**
 * Small pill toggle for Data Saver, dropped into the footer. Lets users on
 * expensive mobile data force lighter pages, and lets diaspora users on fast
 * wifi turn it off for full-quality images.
 */
export default function DataSaverToggle() {
  const { dataSaver, setDataSaver } = useDataSaver()

  return (
    <button
      onClick={() => setDataSaver(!dataSaver)}
      title="Data Saver loads lighter pages and smaller images to save your mobile data"
      aria-pressed={dataSaver}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        background: "transparent",
        border: "1px solid rgba(253,251,247,0.25)",
        borderRadius: 20,
        padding: "5px 12px",
        cursor: "pointer",
        color: "rgba(253,251,247,0.7)",
        fontSize: 12,
        fontFamily: "inherit",
      }}
    >
      <span
        style={{
          width: 28,
          height: 16,
          borderRadius: 10,
          position: "relative",
          background: dataSaver ? "var(--gold)" : "rgba(253,251,247,0.2)",
          transition: "background 0.2s",
          flexShrink: 0,
          display: "inline-block",
        }}
      >
        <span
          style={{
            position: "absolute",
            top: 2,
            left: dataSaver ? 14 : 2,
            width: 12,
            height: 12,
            borderRadius: "50%",
            background: "#fff",
            transition: "left 0.2s",
          }}
        />
      </span>
      Data Saver {dataSaver ? "on" : "off"}
    </button>
  )
}
